import { TestGroupBanner } from "@/components/group/TestGroupBanner";
import { Outlet } from "@tanstack/react-router";

export const GroupLayout = () => {
  return (
    <>
      <TestGroupBanner />
      <Outlet />
    </>
  );
};
